import { render, staticRenderFns } from "./ArticleLike.vue?vue&type=template&id=4b093d76&scoped=true&"
import script from "./ArticleLike.vue?vue&type=script&lang=js&"
export * from "./ArticleLike.vue?vue&type=script&lang=js&"
import style0 from "./ArticleLike.vue?vue&type=style&index=0&id=4b093d76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b093d76",
  null
  
)

export default component.exports